import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Output, EventEmitter } from '@angular/core';
import { IPollSingleAnswer } from '../models/poll.model';
import { ToastController } from 'ionic-angular';


export class PollSingleAbstract {

  constructor(
    public toastCtrl: ToastController
  ) { }

  @Output()
  public sendAnswer: EventEmitter<IPollSingleAnswer> = new EventEmitter();

  public form: FormGroup;

  public buildForm(itsRequired = true) {
    this.form = new FormGroup({
      'id': new FormControl('', Validators.required),
      'value': new FormControl('', Validators.required)
    });
  }

  public patchForm(value) {
    this.form.patchValue(value);
  }

  public onFormSubmited({ value, valid }: { value: IPollSingleAnswer, valid: boolean }) {
    if (valid) {
      this.sendAnswer.emit(value);
    } else {
      this.showMessage('Respuesta invalida, por favor responda la pregunta');
    }
  }

  public showMessage(message: string) {
    this.toastCtrl.create({
      message: message,
      duration: 3000
    }).present();
  }

}


// WEBPACK FOOTER //
// ./src/abstracts/poll-single.abstract.ts